const getLeftOffset = ({
    left, offset, width, tooltipWidth,
}) => {
    if (typeof offset === 'string') {
        if (offset === 'center') {
            return left + (width - tooltipWidth) / 2;
        }

        if (offset.includes('px')) {
            return left + Number(offset.match(/\d+/g));
        }

        throw new Error('the only acceptable string for offset is "center"');
    }
    return left + offset;
};

export {
    getLeftOffset,
};
